module.exports = ".report-description{\r\n    font-style: italic;\r\n}\r\n.form-control{\r\n    width:unset;\r\n}"